<loader *ngIf="loading || loadingIcons"></loader>

<ng-template #intakeNotices>
  <small *ngIf="intakeReadOnly && form.intake.takerName" class="intake-taken-by">{{ "translate.rx.intakeTakenBy" | translate: { name: form.intake.takerName } }}</small>
    <button *ngIf="intakePartyAsks" type="button" class="intake-party-notice" (click)="openIntakeParty()">{{ "translate.intakeParty.notice" | translate }}</button>
    <small *ngIf="intakePartyWaits" class="intake-taken-by">{{ "translate.intakeParty.waiting" | translate }}</small>
    <small *ngIf="mmdSyncNotice" class="intake-taken-by rx-mmd-sync-pending">{{ "translate.intakeParty.waiting" | translate }}</small>
</ng-template>

<div *ngIf="!loading && !loadingIcons" class="header l-align-spaceBetween">
  <h1 *ngIf="!(form.type == 'CLINIC' && form.statusCode == 'DRAFT')">
    {{ "translate.rx.title" | translate }} {{ currentOrder.orderIdMmd }}
    <span> | {{ form.statusDescr }} </span>
    <ng-container *ngTemplateOutlet="intakeNotices"></ng-container>
  </h1>

  <h1 *ngIf="form.type == 'CLINIC' && form.statusCode == 'DRAFT'">
    {{ "translate.rx.formTitleClinic" | translate }}
    <ng-container *ngTemplateOutlet="intakeNotices"></ng-container>
  </h1>

  <div class="actions">
    <p *ngIf="lockNoticeKey">
      <span class="fw-bold">{{ lockNoticeKey | translate: { name: lockState.lockedBy } }}</span>
    </p>

    <p *ngIf="!lockNoticeKey">
      <!-- {{ "translate.rx.updatedAt" | translate }} -->
      <span class="fw-bold">{{ form.updDate | date: "dd/MM/yy HH:mm" }}</span>
      <span> | </span>
      <!-- {{ "translate.rx.updatedBy" | translate }} -->
      <span class="fw-bold">{{ form.updUser }}</span>
    </p>

    <p-select
      *ngIf="readOnly && form.pdf.length > 1"
      class="lang"
      [options]="form.pdf"
      [(ngModel)]="pdf"
      [optionLabel]="'lang'"
      appendTo="body"
    ></p-select>

    <button
      *ngIf="allowSave && dirty && !saving"
      (click)="save()"
      [disabled]="saving || loading"
      class="t-button-outline"
    >
      {{ "translate.rx.save" | translate }}
    </button>

    <button
      *ngIf="allowSign && !saving"
      (click)="save('SIGNED')"
      [disabled]="saving || loading || !signEnabled()"
      pTooltip="{{ signTooltip }}"
      tooltipPosition="bottom"
      class="t-button--success"
    >
      {{ "translate.rx.sign" | translate }}
    </button>

    <button
      *ngIf="intakeMine && !saving"
      (click)="giveBack()"
      [disabled]="saving || loading"
      class="t-button-outline"
    >
      {{ "translate.rx.giveBack" | translate }}
    </button>

    <button
      *ngIf="allowApproveToMmd && !saving"
      (click)="approve()"
      [disabled]="saving || loading"
      class="t-button--success"
    >
      {{ "translate.rx.approveToMmd" | translate }}
    </button>

    <button
      *ngIf="allowOrderActions && !saving"
      (click)="displayMergeRxPopup = true"
      [disabled]="saving || loading"
      class="t-button warn"
    >
      {{ "translate.rx.cancelDuplicateOrder" | translate }}
    </button>

    <button
      *ngIf="allowOrderActions && shilaPoEligible && !saving"
      (click)="displayShilaPoPopup = true"
      [disabled]="saving || loading"
      class="t-button"
    >
      {{ "translate.rx.importShilaPo" | translate }}
    </button>

    <spinner *ngIf="saving"> </spinner>

    <button
      *ngIf="allowChangeToDraft && !saving"
      (click)="save('DRAFT')"
      [disabled]="saving || loading"
      class="t-button-outline"
    >
      {{ "translate.rx.reopen" | translate }}
    </button>

    <button
      *ngIf="allowDelete && !saving"
      (click)="deleteForm()"
      [disabled]="saving || loading"
      class="t-button-outline warn"
    >
      {{ "translate.rx.delete" | translate }}
    </button>
  </div>
</div>

<div
  *ngIf="!loading && !loadingIcons"
  class="rx-form-wrapper"
  id="printable"
  [class.pdf]="pdf"
>
  <div class="body-container">
    <div *ngIf="pdf" class="pdf-container">
      <pdf-viewer [fileUrl]="pdf.fileUrl"></pdf-viewer>
    </div>

    <div *ngIf="!pdf" class="content-container">
      <div class="main">
        <div class="t-widget info">
          <input-wrap
            *ngIf="form.type == 'CLINIC' && displayDoctor"
            label="{{ 'translate.general.doctor' | translate }}"
            cssClass="l-cell-spread"
            [singleLine]="false"
            [required]="true"
            [customValidation]="form.doctor != null"
          >
            <p-select
              class="t-input--colored"
              [options]="doctorList"
              [(ngModel)]="form.doctor"
              [placeholder]="'translate.general.choose' | translate"
              [optionLabel]="'label'"
              appendTo="body"
              [filter]="true"
              [resetFilterOnHide]="true"
              [virtualScroll]="true"
              [virtualScrollItemSize]="30"
              (onChange)="onDrChange()"
            ></p-select>
          </input-wrap>

          <input-wrap
            *ngIf="form.type == 'CLINIC' && displayClinic"
            label="{{ 'translate.general.clinic' | translate }}"
            cssClass="l-cell-spread"
            [singleLine]="false"
            [required]="true"
            [customValidation]="form.clinic != null"
          >
            <p-select
              class="t-input--colored"
              [options]="clinicList"
              [(ngModel)]="form.clinic"
              [placeholder]="'translate.general.choose' | translate"
              [optionLabel]="'label'"
              appendTo="body"
              [filter]="true"
              [resetFilterOnHide]="true"
              [virtualScroll]="true"
              [virtualScrollItemSize]="30"
            ></p-select>
          </input-wrap>

          <input-wrap
            *ngIf="form.type == 'CLINIC'"
            label="{{ 'translate.general.patient' | translate }}"
            cssClass="l-cell-spread "
            [singleLine]="false"
            [required]="true"
          >
            <input
              type="text"
              [(ngModel)]="form.patientDescr"
              class="t-input t-input--colored"
              [disabled]="readOnly"
            />
          </input-wrap>

          <div class="opt" *ngFor="let opt of patientOpt?.options">
            <div style="display: flex; align-items: center">
              <rx-opt-display
                [opt]="opt"
                [label]="false"
                [readOnly]="readOnly"
                [singleLine]="false"
                (onOptValueChange)="dirty = true"
              ></rx-opt-display>

              <span
                *ngIf="opt.id == 'REMOTE_QC' && !opt.selectedValue"
                class="c-warn mandatory-icon"
                aria-label="שדה חובה"
              >
                (*)
              </span>
            </div>
          </div>
        </div>

        <div *ngIf="scanOpt" class="t-widget info properties">
          <!-- <h3 class="m-0">זיהוי הזמנה</h3> -->
          <div class="opt" *ngFor="let opt of scanOpt?.options">
            <rx-opt-display
              *ngIf="displayScanOpt(opt)"
              [opt]="opt"
              [readOnly]="readOnly"
              [singleLine]="false"
              (onOptValueChange)="dirty = true"
            ></rx-opt-display>
          </div>
        </div>

        <div *ngIf="propertiesOpt" class="t-widget info properties">
          <!-- <h3 class="m-0">מאפיינים</h3> -->

          <div class="opt" *ngFor="let opt of propertiesOpt.options">
            <rx-opt-display
              [opt]="opt"
              [readOnly]="readOnly"
              [singleLine]="true"
              (onOptValueChange)="dirty = true"
            ></rx-opt-display>
          </div>
        </div>

        <teeth-edit
          (onDeleteRow)="onLinesChange()"
          (onCreateRow)="onLinesChange()"
          (onChange)="dirty = true"
          [readOnly]="readOnly"
        ></teeth-edit>

        <rx-implants
          *ngIf="implants.length"
          (onDeleteRow)="onLinesChange()"
          [readOnly]="readOnly"
          (onChange)="dirty = true"
        ></rx-implants>

        <div *ngFor="let group of optionGroups" class="t-widget">
          <h3>
            {{ group.optGroupDescr }}
          </h3>
          <div class="rx-opt-container">
            <div *ngFor="let opt of group.options" class="opt">
              <rx-opt-display
                [opt]="opt"
                [readOnly]="readOnly"
                (onOptValueChange)="dirty = true"
              ></rx-opt-display>
            </div>
          </div>
        </div>

        <div class="note-container t-widget">
          <div class="note-side">
            <!-- <h3>הערות</h3> -->

            <div class="elements">
              <div *ngFor="let note of form.notes; let i = index">
                <input-wrap
                  *ngIf="isFreeNote(note)"
                  cssClass="l-cell-spread w-full"
                >
                  <textarea
                    dir="auto"
                    class="t-input t-input--colored"
                    placeholder="תשפכו את הלב כאן"
                    [(ngModel)]="form.notes[i].text"
                    [disabled]="readOnly"
                    (ngModelChange)="dirty = true"
                  ></textarea>
                </input-wrap>

                <div
                  *ngIf="note.drProfileId || note.presetNoteId"
                  class="fixed-note"
                  [class.red]="note.drProfileId && !note.presetNoteId"
                >
                  <p>{{ note.text }}</p>
                  <a *ngIf="!readOnly" (click)="clearNote(note)">
                    <img src="assets\img\clear_input.svg"
                  /></a>
                </div>
              </div>

              <a *ngIf="!readOnly" (click)="addFixedNoteOpenSw = true"
                >+ בנק הערות</a
              >

              <rx-import-details-note
                *ngFor="let note of importDetailsNotes"
                [note]="note"
                [readOnly]="readOnly"
                (remove)="clearNote(note)"
              ></rx-import-details-note>
            </div>
          </div>

          <div class="draw-side">
            <!-- <h3>איזור חופשי</h3> -->
            <draw-area
              [inputDataUrl]="form.canvasDataUrl"
              [readOnly]="readOnly"
              (onChange)="dirty = true"
            ></draw-area>
          </div>

          <div class="shade-container">
            <rx-opt-display
              *ngIf="shade0"
              [opt]="shade0"
              [readOnly]="readOnly"
              (onOptValueChange)="dirty = true"
            ></rx-opt-display>

            <h4 class="norm-title t-panel-cell t-footnote l-align-spaceBetween">
              <span> {{ "translate.rx.shade" | translate }}</span>

              <span> {{ "translate.rx.shadeVita" | translate }}</span>
            </h4>

            <div class="shade-lines">
              <div class="row" *ngIf="shade1">
                <img src="assets\img\shade_top.svg" />
                <rx-opt-display
                  [opt]="shade1"
                  [label]="false"
                  (onOptValueChange)="dirty = true; onShadeValueChange($event)"
                  [readOnly]="readOnly"
                ></rx-opt-display>
              </div>
              <div class="row" *ngIf="shade2">
                <img src="assets\img\shade_middle.svg" />
                <rx-opt-display
                  [opt]="shade2"
                  [label]="false"
                  (onOptValueChange)="dirty = true"
                  [readOnly]="readOnly"
                ></rx-opt-display>
              </div>
              <div class="row" *ngIf="shade3">
                <img src="assets\img\shade_bottom.svg" />
                <rx-opt-display
                  [opt]="shade3"
                  [label]="false"
                  (onOptValueChange)="dirty = true"
                  [readOnly]="readOnly"
                ></rx-opt-display>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!pdf" class="bottom-container">
    <div class="right">
      <div class="files-container">
        <order-files
          [order]="currentOrder"
          (onFileUploaded)="onFileUploaded()"
          [allowUpload]="allowUploadClinicFiles"
          [fromRx]="true"
          [isScrollable]="false"
        ></order-files>
      </div>
    </div>

    <div class="left">
      <div *ngIf="displayRXFiles" class="files-container">
        <order-files
          [order]="currentOrder"
          (onFileUploaded)="onFileUploaded()"
          [allowUpload]="false"
          [fromRx]="true"
          [isRX]="true"
          [isScrollable]="false"
        ></order-files>
      </div>
    </div>
  </div>
</div>

<select-fixed-note
  *ngIf="addFixedNoteOpenSw"
  (onClose)="onFixedNoteClose($event)"
  [preselectedNotes]="form.notes"
  [formId]="form.formId"
></select-fixed-note>

<modal-popup
  *ngIf="showOrderLines"
  [flexible]="true"
  [isOpen]="true"
  [hideHeader]="true"
  [focusOnOpen]="false"
>
  <div class="body-container t-scrollbar">
    <order-lines
      [orderId]="currentOrder?.orderId"
      [orderLines]="orderLines"
      (onSaved)="onOrderLinesSaved()"
      [allowEdit]="true"
      [fromRX]="true"
    ></order-lines>
  </div>
</modal-popup>

<modal-popup
  *ngIf="displayMergeRxPopup"
  [flexible]="true"
  [isOpen]="displayMergeRxPopup"
  [hideHeader]="true"
  [focusOnOpen]="true"
>
  <i
    class="fas fa-times t-popupCloseIcon"
    (click)="displayMergeRxPopup = false"
  ></i>
  <input-wrap
    label="{{ 'translate.general.orderIdMmd' | translate }}"
    cssClass="l-cell-spread"
    [required]="true"
  >
    <input
      type="text"
      [(ngModel)]="mergeOrderIdMmd"
      class="t-input t-input--colored"
    />
  </input-wrap>

  <button (click)="cancelDuplicateOrder()" class="t-button--success">
    {{ "translate.rx.cancelDuplicateOrder" | translate }}
  </button>
</modal-popup>

<modal-popup
  *ngIf="displayGiveBackPopup"
  [flexible]="true"
  [isOpen]="displayGiveBackPopup"
  [hideHeader]="true"
  [focusOnOpen]="true"
>
  <i class="fas fa-times t-popupCloseIcon" (click)="displayGiveBackPopup = false"></i>
  <p>{{ "translate.rx.giveBackUnsaved" | translate }}</p>
  <button (click)="saveAndGiveBack()" class="t-button--success">
    {{ "translate.rx.save" | translate }}
  </button>
  <button (click)="discardAndGiveBack()" class="t-button-outline warn">
    {{ "translate.rx.giveBackDiscard" | translate }}
  </button>
</modal-popup>

<modal-popup *ngIf="displayShilaPoPopup" [flexible]="true" [isOpen]="displayShilaPoPopup" [hideHeader]="true" [wide]="true">
  <i class="fas fa-times t-popupCloseIcon" (click)="closeShilaPo()"></i>
  <shila-po-dialog [orderId]="currentOrder.orderId" (changed)="onShilaPosChanged()"></shila-po-dialog>
</modal-popup>

<modal-popup *ngIf="displayIntakePartyPopup" [flexible]="true" [isOpen]="displayIntakePartyPopup" [hideHeader]="true">
  <i class="fas fa-times t-popupCloseIcon" (click)="closeIntakeParty()"></i>
  <intake-party-dialog
    [orderId]="currentOrder.orderId"
    [orderClinicId]="currentOrder.clinicId"
    [patientName]="currentOrder.patientFullName"
    [merging]="intakeMerging"
    (changed)="onIntakePartyChanged()"
    (finished)="onIntakePartyFinished($event)"
    (mergeInto)="onIntakePartyMerge($event)"
  ></intake-party-dialog>
</modal-popup>
